export default "__VITE_ASSET__BwWuynqk__"